/**
 * Which landing to show on "/" based on calendar day of month:
 * 1–10: standard home
 * 11–20: Ley-style page
 * 21–end: Falcon-style page
 */
export function getCalendarHomeVariant() {
  const day = new Date().getDate();
  if (day >= 1 && day <= 10) return 'home';
  if (day >= 11 && day <= 20) return 'ley';
  return 'falcon';
}
